<template>
    <div>
        <div class="flex gap-2 mb-4">
            <label class="w-14 flex-shrink-0 text-sm">Preset</label>
            <div class="flex flex-wrap gap-1">
                <div v-for="(color, i) in gradient_colors" :key="i" @click="setGradientColor(color)"
                    class="w-6 h-6 border border-gray-200 rounded-sm cursor-pointer" :style="{
                        background: 'linear-gradient(' + color.join(',') + ')',
                    }" :class="{
    'border-white shadow shadow-sky-600': CheckGradientColorSelect(
        'dotsOptions',
        color
    ),
}"></div>
            </div>
        </div>
        <template v-if="config.dotsOptions.gradient">
            <div class="flex gap-2 mb-4">
                <label class="w-14 flex-shrink-0 text-sm">Picker</label>
                <div class="flex gap-2 items-center" v-if="config.dotsOptions.gradient">
                    <div class="w-6 h-6 border border-gray-200 rounded-sm cursor-pointer" :style="{
                        backgroundColor: config.dotsOptions.gradient.colorStops[0].color,
                    }" @click="$refs.cg_1.click()">
                        <input type="color" class="opacity-0 overflow-hidden" ref="cg_1" @change="UpdateGradient1" />
                    </div>
                    <ArrowRightIcon size="18" stroke-width="1" />
                    <div class="w-6 h-6 border border-gray-200 rounded-sm cursor-pointer" :style="{
                        backgroundColor: config.dotsOptions.gradient.colorStops[1].color,
                    }" @click="$refs.cg_2.click()">
                        <input type="color" class="opacity-0 overflow-hidden" ref="cg_2" @change="UpdateGradient2" />
                    </div>
                    <template v-if="config.dotsOptions.gradient.colorStops[2]">
                        <ArrowRightIcon size="18" stroke-width="1" />
                        <div class="relative">
                            <div class="w-6 h-6 border border-gray-200 rounded-sm cursor-pointer" :style="{
                                backgroundColor:
                                    config.dotsOptions.gradient.colorStops[2].color,
                            }" @click="$refs.cg_3.click()">
                                <input type="color" class="opacity-0 overflow-hidden" ref="cg_3"
                                    @change="UpdateGradient3" />
                            </div>
                            <span @click="removeColor3"
                                class="bg-black cursor-pointer rounded-full absolute -top-1 -right-1 flex items-center justify-center">
                                <XIcon class="text-white w-3 h-3" />
                            </span>
                        </div>
                    </template>
                    <template v-else>
                        <span @click="AddColor"
                            class="text-xs cursor-pointer h-4 flex items-center justify-center px-2 rounded-sm hover:bg-hvcolor">
                            Add Color
                        </span>
                    </template>
                </div>
            </div>
            <div class="flex gap-2 mb-4" v-if="config.dotsOptions.gradient">
                <label class="w-14 flex-shrink-0 text-sm">Type</label>
                <div class="flex items-center gap-3">
                    <div class="flex items-center">
                        <input id="gradient_type1" checked type="radio" :value="'linear'" v-model="config.dotsOptions.gradient.type"
                            name="gradient_type" class="w-5 h-5 accent-success bg-gray-100 border-gray-300   ">
                        <label for="gradient_type1"
                            class="w-full ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Linear</label>
                    </div>
                    <div class="flex items-center ">
                        <input  id="gradient_type2" :value="'radial'" type="radio"
                            v-model="config.dotsOptions.gradient.type" value="" name="gradient_type"
                            class="w-5 h-5 accent-success bg-gray-100 border-gray-300   ">
                        <label for="gradient_type2"
                            class="w-full ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">Radial</label>
                    </div>
                </div>

            </div>
            <div class="flex gap-2 mb-4" v-if="ValueModeGradient == 'linear'">
                <label class="w-14 flex-shrink-0 text-sm">Rotation</label>
                <input type="number" class="h-10 rounded-sm px-2" :value="ValueRotationGradient"
                    @change="UpdateRotationGradient" />
            </div>
        </template>
    </div>
</template>
<script>
import { useQrCreateStore } from "~~/stores/qrcreate";
import configMixins from "../config.mixin";
import { ArrowRightIcon, XIcon } from "vue-tabler-icons";

export default {
    components: {
        ArrowRightIcon,
        XIcon,
    },
    mixins: [configMixins],
    data() {
        return {
            gradient_colors: [
                ["rgb(1, 52, 121)", " rgb(1, 30, 69)"],
                ["rgb(3, 74, 158)", " rgb(2, 50, 107)"],
                ["rgb(54, 95, 147)", " rgb(36, 63, 97)"],
                ["rgb(97, 120, 145)", " rgb(63, 78, 94)"],
                ["rgb(74, 144, 226)", " rgb(58, 112, 176)"],
                ["rgb(4, 119, 122)", " rgb(2, 70, 71)"],
                ["rgb(65, 117, 5)", " rgb(37, 66, 3)"],
                ["rgb(104, 181, 107)", " rgb(33, 147, 142)"],
                ["rgb(155, 155, 155)", " rgb(52, 52, 58)"],
                ["rgb(107, 80, 114)", " rgb(60, 45, 64)"],
                ["rgb(200, 109, 215)", " rgb(134, 74, 158)"],
                ["rgb(218, 37, 28)", " rgb(166, 28, 21)"],
                ["rgb(245, 81, 95)", " rgb(194, 64, 75)"],
                ["rgb(255, 133, 0)", " rgb(242, 68, 0)"],
                ["rgb(249, 174, 70)", " rgb(247, 107, 28)"],
                ["rgb(238, 220, 203)", " rgb(227, 190, 157)"],
            ],
        };
    },
    computed: {
        ValueModeGradient() {
            if (this.config.dotsOptions.gradient) {
                return this.config.dotsOptions.gradient.type;
            }
            return "linear";
        },
        ValueRotationGradient() {
            if (this.config.dotsOptions.gradient) {
                return this.config.dotsOptions.gradient.rotation;
            }
            return "";
        },
        Color1Gradient() {
            if (this.config.dotsOptions.gradient) {
                return this.config.dotsOptions.gradient.colorStops[0].color;
            }
            return "";
        },
        Color2Gradient() {
            if (this.config.dotsOptions.gradient) {
                return this.config.dotsOptions.gradient.colorStops[1].color;
            }
            return "";
        },
    },
    methods: {
        UpdateGradient1(e) {
            useQrCreateStore().setGradientByKey({
                key: "dotsOptions",
                data: {
                    color1: e.target.value,
                },
            });
            this.$forceUpdate();
        },
        UpdateGradient2(e) {
            useQrCreateStore().setGradientByKey({
                key: "dotsOptions",
                data: {
                    color2: e.target.value,
                },
            });
            this.$forceUpdate();
        },
        UpdateGradient3(e) {
            useQrCreateStore().setGradientByKey({
                key: "dotsOptions",
                data: {
                    color3: e.target.value,
                },
            });
            this.$forceUpdate();
        },
        UpdateTypeGradient(e) {
            useQrCreateStore().setGradientByKey({
                key: "dotsOptions",
                data: { mode: e.target.value },
            });
            useQrCreateStore().$forceUpdate();
        },
        UpdateRotationGradient(e) {
            useQrCreateStore().setGradientByKey({
                key: "dotsOptions",
                data: { rotation: e.target.value },
            });
        },
        setGradientColor(colors) {
            useQrCreateStore().setGradientByKey({
                key: "dotsOptions",
                data: {
                    color1: colors[0],
                    color2: colors[1],
                },
            });
            this.$forceUpdate();
        },
        AddColor() {
            useQrCreateStore().setGradientByKey({
                key: "dotsOptions",
                data: {
                    color3: this.config.dotsOptions.gradient.colorStops[1].color,
                },
            });

        },
        removeColor3() {
            const colorArray = this.config.dotsOptions.gradient.colorStops
            colorArray.splice(colorArray.length-1,1)
            this.config.dotsOptions.gradient.colorStops = colorArray
            this.$forceUpdate();
        },
    },
};
</script>
  